import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Typography } from "../../../Typography/index.js";
import { Box } from "../../../Box/index.js";
const FileError = (t0)=>{
    const $ = c(2);
    const { text } = t0;
    const t1 = text || "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A";
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ jsx(Box, {
            pt: "4",
            display: "flex",
            justifyItems: "center",
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "accent.text.error",
                children: t1
            })
        });
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
};
export { FileError };
